<template>
  <div class="print-tag">
    <transition
      :name="effect"
      mode="out-in"
    >
      <print-tag-main-view />
    </transition>
  </div>
</template>

<script>
import printTagMainView from './PrintTagMainView'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PrintTag',
  components: {
    'print-tag-main-view': printTagMainView
  },
  data: () => ({
    effect: 'slide-fade'
  }),
  computed: {
    ...mapGetters(['isBatchFilterShowing', 'preference'])
  },
  watch: {
    isBatchFilterShowing: function (newVal) {
      if (newVal) {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    },
    $route (to, from) {
      this.setListTypeByPath()
    }
  },
  mounted () {
    this.setListTypeByPath()
  },
  methods: {
    ...mapActions(['setFilterShowOff', 'setPrintTagListType', 'setFilterShowOff']),
    setListTypeByPath () {
      if (this.$route.path === '/print-tag/filter') {
        this.setFilterShowOff(true)
      } else {
        this.setFilterShowOff(false)
        if (this.$route.path === '/print-tag/batches') {
          this.setPrintTagListType('batches')
        } else if (this.$route.path === '/print-tag/samples') {
          this.setPrintTagListType('samples')
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";
@import "../../../static/stylesheets/components/orders/empty-cart";

.print-tag {
  height: 100%;

  .print-tag-batches {
    &__card-container {
      align-items: flex-start;
      display: flex;
      height: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-left: 0;
      padding: 0;

      .card-box {
        margin: 15px 30px 30px 0px;

        &-printed {
          margin: 15px 30px 40px 0px;
        }
      }
      .collapsed {
        width: 100%;
        display: flex;
      }
    }

    .subsection-container {
      width: 100%;
      padding-top: 100px;

      &-alternative {
        padding-top: 30px !important;
      }

      h2 {
        font-size: 18px;
        font-weight: 400;
        letter-spacing: -0.3px;
        text-align: left;
        color: #7a7a7a;
        line-height: 1.09;
      }

      hr {
        margin-top: 15px;
        margin-bottom: 15px;
        background-color: #828282;
        height: 0.11em;
        border: 0;
        width: 95%;
        opacity: 0.9;
      }
    }
    &-empty-reload-snackbar.md-snackbar {
      bottom: -10px;

      .md-snackbar {
        &-container {
          min-width: 910px;
          padding: 13px 24px;
          background-color: #7c0a02;
        }

        &-content {
          display: flex;
          flex-direction: row;
          height: 12px;
          letter-spacing: -0.5px;
        }
      }

      .md-button {
        color: rgba(255, 255, 255, 0.5);
        padding: 0 10px;
        margin: -11px 0 0 25px;

        &:last-child {
          margin-left: 2px;
          color: #e1e1e1;
        }
      }
    }

    .md-list {
      width: 80%;
      padding-top: 0;
      margin-left: 21px;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter {
    transform: translateY(300px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-400px);
    opacity: 0;
  }
  .leave-fade-enter-active {
    transition: all 0.3s ease;
  }
  .leave-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .leave-fade-enter {
    transform: translateY(-450px);
    opacity: 0;
  }
  .leave-fade-leave-to {
    transform: translateY(450px);
    opacity: 0;
  }
  .alternative-subheader {
    position: initial;
  }
}

.export-print-tag.modals .md-dialog {
  min-width: 660px;
  min-height: 230px;
  border-radius: 7px;

  &-title {
    padding: 32px 34px 13px;
    font-size: 24px;
    font-weight: 300;
    letter-spacing: -0.3px;
    color: rgba(96, 96, 96, 0.87);
  }

  .close-button {
    position: absolute;
    top: 23px;
    right: 38px;
  }

  p {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
    margin-bottom: 10px;
  }
}

.print-tag-modal-details {
  &__title {
    font-weight: 500;
    color: #4a4a4a;
    font-family: Roboto, sans-serif;
    font-size: 18px;

    .md-icon {
      margin-right: 0.5em;
    }
  }

  .md-dialog-content {
    padding-top: 0px;
  }

  &__description {
    font-family: Roboto, sans-serif;
    color: #617173;
    font-weight: normal;

    p {
      font-size: 15px !important;
      text-align: left !important;
    }
    span {
      font-weight: 500;
    }
  }

  &__button {
    width: 40%;
    margin: 3% 3% 0 3%;
  }

  .button-single {
    float: left;
    width: 60%;
    margin-left: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
